export enum SCROLL_CONST {
  TEST_ID = 'scrollbar',
}

export enum COLOR {
  ALERT = 'alert',
  DARKLIGHT = 'darkLight',
  DISABLED = 'disabled',
  ERROR = 'error',
  MEDIUM = 'medium',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  SUCCESS = 'success',
}

export enum SIZE {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
